import { render } from "./PrintFooterDesign3.vue?vue&type=template&id=ad010fa0&scoped=true"
import script from "./PrintFooterDesign3.vue?vue&type=script&lang=js"
export * from "./PrintFooterDesign3.vue?vue&type=script&lang=js"

import "./PrintFooterDesign3.vue?vue&type=style&index=0&id=ad010fa0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad010fa0"]])

export default __exports__